var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.oldSrc,staticClass:"img-wrap"},[(_vm.loaded)?_c('div',{staticClass:"loading-animation",style:(_vm.loadingHeight ? 'height:' + _vm.loadingHeight + 'px' : '')},[_c('i',{staticClass:"game-bg-icon"},[_c('Icon',{attrs:{"type":"game-load-bg"}})],1)]):_c('img',{staticClass:"img",attrs:{"src":_vm.oldSrc,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }